import React from "react";
import classNames from "classnames";
import { Link } from "@/components/Link";
import { Lazy } from "@/components/Lazy";
import { checkValidURL } from "@/utils/formHelper";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";
import { shouldEagerLoadPreviewImage } from "@/features/previews/shared/utils/previewImage";
import "./SharedLinkCard.scss";

export interface SharedLinkCardProps {
  /** Text to display on the link */
  text: string;
  /** Destination URL */
  url: string;
  /** Optional image URL to display alongside the text */
  imageUrl?: string;
  /** Background color for the card */
  buttonColor?: string;
  /** Additional CSS class */
  className?: string;
}

export function SharedLinkCard({
  text,
  url,
  imageUrl,
  buttonColor,
  className,
}: SharedLinkCardProps) {
  const validUrl = checkValidURL(url) || "";
  const shouldEagerLoad = shouldEagerLoadPreviewImage(imageUrl);
  const imageSrc = shouldEagerLoad
    ? imageUrl
    : optimizeCloudinaryImage({
        url: imageUrl ?? "",
      });

  return (
    <Link
      externalLink
      type="button"
      className={classNames("shared-link-card", className)}
      href={validUrl}
      style={{ backgroundColor: buttonColor }}
      prefetch={false}
    >
      {imageUrl && (
        <Lazy
          placeholderClass="shared-link-card__img-placeholder"
          preventLazy={shouldEagerLoad}
        >
          <img
            className="shared-link-card__img"
            src={imageSrc}
            alt={text}
            loading={shouldEagerLoad ? "eager" : undefined}
            decoding="async"
          />
        </Lazy>
      )}
      <span className="shared-link-card__text">{text}</span>
    </Link>
  );
}
